<template>
  <div class="settings">
    <div class="header">SETTINGS</div>
    <div class="row">
      <div class="small-6 columns padding-R">
        <settings-group v-for="(group, index) in getGroup(0)" :key="'col1_' + index" :column="0" :groupKey="group.key"
          :groupTitle="group.object.title" :itemKeys="getKeys(group.object.items)"></settings-group>
      </div>
      <div class="small-6 columns padding-L">
        <settings-group v-for="(group, index) in getGroup(1)" :key="'col2_' + index" :column="1" :groupKey="group.key"
          :groupTitle="group.object.title" :itemKeys="getKeys(group.object.items)"></settings-group>
      </div>
    </div>

    <div class="controls">
      <a href="javascript:;" v-bind:class="{ 'button cta success small': true, disabled: saving }" @click="save" v-show="!success">
        <i class="fa fa-spinner fa-spin" v-show="saving"></i>
        <span v-show="!saving">SAVE CHANGES</span>
      </a>
      <div class="success-message" v-show="success">
        <i class="fa fa-check-circle fa-2x"></i>
        <span>SETTINGS SUCCESSFULLY UPDATED!</span>
      </div>
    </div>
  </div>
</template>

<script>
import SettingsConfig from './settings-config/index'
import SettingsGroup from './SettingsGroup'
export default {
  name: 'settings',
  components: { SettingsGroup },
  data () {
    return {
      saving: false,
      success: false
    }
  },
  methods: {
    getGroup (index) {
      let object = SettingsConfig[index]
      let result = []
      for (let property in object) {
        if (!object.hasOwnProperty(property)) {
          continue
        }
        result.push({
          key: property,
          object: object[property]
        })
      }
      return result
    },
    getKeys (object) {
      let result = []
      for (let property in object) {
        if (!object.hasOwnProperty(property)) {
          continue
        }
        result.push(property)
      }
      return result
    },
    save () {
      let self = this

      self.saving = true
      self.success = false
      self.$sdk.post('/settings', {
        token: self.$store.state.session.sessionToken,
        settings: self.buildRequest()
      }, r => {
        self.saving = false
        console.log(r)
        if (r.error) {
          return
        }
        self.success = true
        setTimeout(() => {
          self.success = false
        }, 2000)
      })
    },
    buildRequest () {
      let self = this
      let config = self.$store.state.settingsPage.configuration

      let result = {}
      for (let key in config) {
        if (!config.hasOwnProperty(key)) {
          continue
        }
        result[key] = config[key].value
      }

      return result
    }
  },
  mounted () {
    let self = this
    self.$sdk.get('/settings', {}, r => {
      if (r.error) {
        console.log('ERROR', r)
        return
      }
      self.$store.commit('settingsPage/setConfiguration', r)
    })
  }
}
</script>

<style lang="scss" scoped>
.settings {
  margin-bottom: 70px;
}
.header {
  font-weight: 700;
  font-size: 22px;
  color: #3F2975;
  background-color: #fff;
  display: block;
  line-height: 22px;
  padding: 14px 0 14px 64px;
  border-bottom: 1px solid rgba(0,0,0,0.15);
}

.padding-L{ padding-left: 7px; }
.padding-R{ padding-right: 7px; }

.controls {
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #fff;
  width: 100%;
  box-shadow: 0 -2px 4px rgba(0,0,0,0.2);
  padding: 15px 0;
  text-align: center;

  & > .button {
    width: 200px;
  }
}

.success-message {
  font-weight: 700;
  color: #555;
  padding: 3px 0;
  & > * {
    display: inline-block;
    vertical-align: middle;
  }
  & > i {
    color: #26D97A;
  }
}

@media only screen and (max-width: 430px) {
  .small-6 {
    width: 100%;
  }

  .padding-L, .padding-R {
    padding: 10px 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Settings/index.vue